import React from 'react';
import {StyleSheet, Text, View} from 'react-native';
import {colors} from 'src/assets';

export type SectionProps = {
  text: string;
};

export const Section: React.FC<SectionProps> = ({text}) => {
  return (
    <View style={styles.root}>
      <Text style={styles.text}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 16,
  },
  text: {
    fontSize: 12,
    fontWeight: '600',
    color: colors.chokuGray,
  },
});
